import { type destinationsSummaryQuery } from "../DestinationsTable";
import { type VariablesOf } from "@/graphql";

type SortingField = NonNullable<NonNullable<VariablesOf<typeof destinationsSummaryQuery>["sortBy"]>[0]>["field"];

export const SUMMARY_SORT_FIELDS = [
  "BUSINESS_NAME",
  "NUMBER_OF_HEAD",
  "NUMBER_OF_HEAD_PLANNED",
  "NUMBER_OF_HEAD_BOOKED",
  "NUMBER_OF_HEAD_SHIPPED",
] as const satisfies readonly SortingField[];

export type SummarySortField = (typeof SUMMARY_SORT_FIELDS)[number];
